import React from 'react';

import { Box, CircularProgress } from '@mui/material';

import { useResponsive } from '../../hooks/useResponsive';
import { HEADER_HEIGHT_DESKTOP, HEADER_HEIGHT_MOBILE } from '../Header/headerConstants';

export interface LoaderProps {
  height?: string;
  withLayout?: boolean;
  color?: string;
}

export const Loader = ({ height = '100vh', withLayout, color }: LoaderProps) => {
  const isDesktop = useResponsive('up', 'lg');

  const headerHeight = isDesktop ? HEADER_HEIGHT_DESKTOP : HEADER_HEIGHT_MOBILE;
  const layoutPadding = headerHeight + 48 * 2;

  return (
    <Box
      data-testid="loader"
      sx={{
        display: 'flex',
        alignItems: 'center',
        height: withLayout ? `calc(100vh - ${headerHeight + layoutPadding}px)` : height,
        justifyContent: 'center',
      }}
    >
      <CircularProgress sx={{ color: color || 'primary.main' }} />
    </Box>
  );
};
